var exports = {
  "wm": "xfb577c5e--2e229b--logo",
  "yr": "xfb577c5e--2e229b--logo-image",
  "_j": "xfb577c5e--2e229b--logo-default",
  "Gp": "xfb577c5e--2e229b--logo-default-content",
};

module.exports = exports;
